import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { formatTimeAMPM } from "../../../Utils/timeUtils";
import { toProperCase } from "../../../Utils";
import * as route from "../../../routes";
import { ACTION_APPROVED, ACTION_REJECTED, APPROVED, REJECTED, getStatusBadgeClasses } from "../constants";
import RejectPopup from "./RejectPopup";


const MobileAttendanceCard = ({
  data,
  displayActionButtons = false,
  handleApproval,
  setActiveRejectRow,
  activeRejectRow,
}) => {
  const navigate = useNavigate();
  const { site_name, date, checkin_time, checkout_time, is_backdated, user_name } = data;
  const location = useLocation();
  const filters = location.state?.filters || { status: "", date: null, user: "" };
  

  return (
    <>
      <div>
        <div className="flex justify-between p-4 shadow-md mb-2">
          <div
            onClick={() =>
              navigate(route.VIEW_DETAILED_PAGE.replace(":id", data.id), {
                state: { ...location.state, filters, from: location.pathname },
              })
            }
          >
            <div className="flex flex-col">
              <span className="font-semibold text-primary">{site_name}</span>
              <span className="font-semibold text-primary">{user_name}</span>
            </div>
            <div className="flex gap-2">
              <span className="text-gray-600">{date}</span>
              <div className="flex gap-1">
                <span className="text-primary">
                  {formatTimeAMPM(checkin_time)}
                </span>
                {checkout_time && <span className="text-gray-600">-</span>}
                <span className="text-red-600">
                  {formatTimeAMPM(checkout_time)}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-1">
              {is_backdated === "Yes" && (
                <span className="text-violet-700 bg-violet-100 text-xs font-medium px-2 py-1 rounded-full">Backdated</span>
              )}

              <span
                className={`text-xs font-medium px-2 py-1 rounded-full ${getStatusBadgeClasses(
                  data.status
                )}`}
              >
                {toProperCase(data.status)}
              </span>
            </div>
          </div>

          <div className="flex flex-col justify-between items-center">
            {displayActionButtons && (
              <>
                <button
                  className={`${(data.status === APPROVED || data.status === REJECTED) ? "text-gray-400" : "text-primary"}  p-2 rounded-full`}
                  disabled={data.status === APPROVED || data.status === REJECTED}
                  onClick={() => handleApproval(data.id, ACTION_APPROVED)}
                >
                  <FaCheck size={25} />
                </button>
                <button
                  className={`${(data.status === APPROVED || data.status === REJECTED) ? "text-gray-400" : "text-red-500"}  p-2 rounded-full`}
                  disabled={data.status === APPROVED || data.status === REJECTED}
                  onClick={() => setActiveRejectRow(data)}
                >
                  <FaTimes size={25} />
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Popup rendered conditionally if active */}
      {displayActionButtons && activeRejectRow?.id === data.id && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <RejectPopup
            id={data.id}
            action={ACTION_REJECTED}
            handleApproval={(id, action, rejection_reason) =>
              handleApproval(id, action, rejection_reason)
            }
            setActiveRejectRow={() => setActiveRejectRow(null)}
          />
        </div>
      )}
    </>
  );
};

export default MobileAttendanceCard;
